/**
 * HelloWorld字符串，值是'Hello World!'
 */
export const Hello = 'Hello World!'

export { default as sum } from './test'

/**
 * 平面二维坐标系的一个点
 */
export interface Point {
  /**
   * x轴位置
   */
  x: number

  /**
   * y轴位置
   */
  y: number
}
